import state from "./state";
import getters from "./getters";
import mutations from "./mutations.js";
import actions from "./actions";

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};
